module.exports = __webpack_public_path__ + "static/media/icon-event__revolucion-rusa.3f459318.svg";